var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "add-modal-gestionar-despacho",
                  staticStyle: {
                    display: "flex !important",
                    "flex-direction": "column"
                  },
                  attrs: { dark: "", color: "primary", fixed: "" }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { layout: "", "align-center": "", md6: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: { click: _vm.handlePopUp }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                      _c("v-toolbar-title", [
                        _vm._v(
                          "\n            Gestionar Despacho " +
                            _vm._s(_vm.data.nombre_add) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        flex: "",
                        md6: "",
                        layout: "",
                        "justify-end": ""
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "btn-step-nav" },
                        [
                          _vm.currentStep > 1
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-anterior",
                                  on: { click: _vm.prevStep }
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("arrow_back")
                                  ]),
                                  _vm._v("Anterior\n            ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentStep < 2
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-siguiente",
                                  on: { click: _vm.nextStep }
                                },
                                [
                                  _vm._v("\n              Siguiente"),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("arrow_forward")
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentStep === 2
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-guardar",
                                  on: { click: _vm.handleSaveStep2 }
                                },
                                [
                                  _vm._v(
                                    "\n              Guardar Cambios\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "v-stepper",
                {
                  staticClass: "gestionar-despacho-stepper",
                  model: {
                    value: _vm.currentStep,
                    callback: function($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            complete: _vm.currentStep > 1,
                            step: "1",
                            color: "primary"
                          }
                        },
                        [_vm._v("\n            Agregar Equipo\n          ")]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        { attrs: { step: "2", color: "primary" } },
                        [
                          _vm._v(
                            "\n            Generar Movimiento y Encomienda\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-items",
                    [
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "1" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cardnew",
                              attrs: { align: "center" }
                            },
                            [
                              _c("br"),
                              _c(
                                "v-flex",
                                { attrs: { md10: "", "mt-2": "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c(
                                        "v-container",
                                        { attrs: { "grid-list-md": "" } },
                                        [
                                          _c(
                                            "div",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { md12: "" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "h2_title mb-1"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Agregar Equipo"
                                                          )
                                                        ]
                                                      ),
                                                      _c("v-divider"),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { md12: "" } },
                                                        [
                                                          !_vm.loading_equipo
                                                            ? _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    md12: "",
                                                                    layout: "",
                                                                    "mt-4": "",
                                                                    "mb-5": "",
                                                                    "px-5": ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs6: "",
                                                                        sm5: "",
                                                                        lg4: "",
                                                                        "mx-2":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "DatePicker",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "Fecha Despacho",
                                                                            disabled:
                                                                              _vm
                                                                                .validateFieldEmpty_equipo
                                                                                .fecha_despacho
                                                                          },
                                                                          on: {
                                                                            input:
                                                                              _vm.handleChangeDateEquipo
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .objParam_equipo
                                                                                .fecha_despachador,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.objParam_equipo,
                                                                                "fecha_despachador",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "objParam_equipo.fecha_despachador"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs6: "",
                                                                        sm5: "",
                                                                        lg4: "",
                                                                        "mx-2":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-autocomplete",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "Despachado Por",
                                                                            "prepend-icon":
                                                                              "person",
                                                                            items:
                                                                              _vm.users
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .objParam_equipo
                                                                                .despachador,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.objParam_equipo,
                                                                                "despachador",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "objParam_equipo.despachador"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                md12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "0.5px solid #aeacac75",
                                                                    "border-top-right-radius":
                                                                      "5px",
                                                                    "border-top-left-radius":
                                                                      "5px",
                                                                    display:
                                                                      "flex",
                                                                    "padding-left":
                                                                      "10px"
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        md6: "",
                                                                        layout:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-flex",
                                                                        {
                                                                          attrs: {
                                                                            xs12:
                                                                              "",
                                                                            md8:
                                                                              "",
                                                                            xl6:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-text-field",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "Buscar...",
                                                                                outlined:
                                                                                  "",
                                                                                "append-icon":
                                                                                  "search",
                                                                                clearable:
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                keyup:
                                                                                  _vm.handleSearchEquipo
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm.quickSearch,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.quickSearch = $$v
                                                                                },
                                                                                expression:
                                                                                  "quickSearch"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        md6: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "my-3",
                                                                          staticStyle: {
                                                                            "padding-right":
                                                                              "20px"
                                                                          },
                                                                          attrs: {
                                                                            color:
                                                                              "#ffe800"
                                                                          },
                                                                          on: {
                                                                            click:
                                                                              _vm.cargarDispositivosTodos
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticStyle: {
                                                                                color:
                                                                                  "black"
                                                                              },
                                                                              attrs: {
                                                                                dark:
                                                                                  "",
                                                                                left:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "add_circle_outline"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle: {
                                                                                color:
                                                                                  "black"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Agregar Dispositivos"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                sm12: "",
                                                                md12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "GridComponent",
                                                                {
                                                                  staticClass:
                                                                    "ag-theme-material",
                                                                  staticStyle: {
                                                                    border:
                                                                      "0.5px solid #aeacac75",
                                                                    "border-bottom-right-radius":
                                                                      "5px",
                                                                    "border-bottom-left-radius":
                                                                      "5px"
                                                                  },
                                                                  attrs: {
                                                                    "grid-options":
                                                                      _vm.gridOptions_equipo
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("br")
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                layout: "",
                                "justify-end": "",
                                "mt-3": "",
                                "mb-4": "",
                                "mr-4": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-guardar",
                                  on: { click: _vm.handleSaveEquipo }
                                },
                                [_c("span", [_vm._v("Guardar Cambios")])]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-stepper-content", { attrs: { step: "2" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "cardnew",
                            attrs: { align: "center" }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md10: "", "pt-5": "" } },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "rounded-card" },
                                  [
                                    _c(
                                      "v-container",
                                      { attrs: { "grid-list-md": "" } },
                                      [
                                        _c(
                                          "div",
                                          { attrs: { align: "left" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { sm12: "" } },
                                              [
                                                _c(
                                                  "h2",
                                                  { staticClass: "h2_title" },
                                                  [_vm._v("Generar Movimiento")]
                                                ),
                                                _c("v-divider"),
                                                !_vm.loading_movi
                                                  ? _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          sm12: "",
                                                          layout: "",
                                                          wrap: "",
                                                          "pa-4": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                value:
                                                                  "Por Asignar",
                                                                label:
                                                                  "movimiento",
                                                                type: "text",
                                                                disabled: "",
                                                                "prepend-icon":
                                                                  "123"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Usuario",
                                                                type: "text",
                                                                disabled: "",
                                                                "prepend-icon":
                                                                  "person"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .paramApi_movi
                                                                    .usuario
                                                                    .nombre,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .paramApi_movi
                                                                      .usuario,
                                                                    "nombre",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi_movi.usuario.nombre"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Operación",
                                                                  disabled: "",
                                                                  items:
                                                                    _vm
                                                                      .listApi_movi
                                                                      .operaciones,
                                                                  "item-value":
                                                                    "operacion_id",
                                                                  "item-text":
                                                                    "operacion_name",
                                                                  "prepend-icon":
                                                                    "home_repair_service",
                                                                  "return-object":
                                                                    ""
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .paramApi_movi
                                                                      .operacion,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi_movi,
                                                                      "operacion",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi_movi.operacion"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Origen",
                                                                  disabled: "",
                                                                  "prepend-icon":
                                                                    "departure_board",
                                                                  items:
                                                                    _vm
                                                                      .listApi_movi
                                                                      .destinos,
                                                                  "item-value":
                                                                    "tipoubicaid",
                                                                  "item-text":
                                                                    "tipoubicaname",
                                                                  "return-object":
                                                                    ""
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.handleChangeMovi
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .paramApi_movi
                                                                      .origen,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi_movi,
                                                                      "origen",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi_movi.origen"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Destino (Obligatorio)",
                                                                  "prepend-icon":
                                                                    "flag",
                                                                  items:
                                                                    _vm
                                                                      .listApi_movi
                                                                      .destinosDisponibles,
                                                                  rules: [
                                                                    _vm
                                                                      .rules_movi
                                                                      .destino
                                                                  ],
                                                                  "item-value":
                                                                    "tipoubicaid",
                                                                  required: "",
                                                                  "item-text":
                                                                    "tipoubicaname",
                                                                  "return-object":
                                                                    ""
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.handleChangeMovi
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .paramApi_movi
                                                                      .destino,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi_movi,
                                                                      "destino",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi_movi.destino"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Crear encomienda",
                                                                  "prepend-icon":
                                                                    "123",
                                                                  items:
                                                                    _vm
                                                                      .listApi_movi
                                                                      .numDespachos,
                                                                  "item-value":
                                                                    "despanumero",
                                                                  "item-text":
                                                                    "despaseguimiento",
                                                                  "return-object":
                                                                    "",
                                                                  clearable: ""
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.handleChangeMovi
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .paramApi_movi
                                                                      .numDespacho,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi_movi,
                                                                      "numDespacho",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi_movi.numDespacho"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Caja Número",
                                                                type: "text",
                                                                "prepend-icon":
                                                                  "123"
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.handleChangeMovi
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .paramApi_movi
                                                                    .movicajanro,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi_movi,
                                                                    "movicajanro",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi_movi.movicajanro"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm4: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Estado (Obligatorio)",
                                                                  "prepend-icon":
                                                                    "update",
                                                                  items:
                                                                    _vm
                                                                      .listApi_movi
                                                                      .estados,
                                                                  "item-value":
                                                                    "estado_id",
                                                                  "item-text":
                                                                    "estado_name",
                                                                  required: "",
                                                                  "return-object":
                                                                    ""
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.handleChangeMovi
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .paramApi_movi
                                                                      .estado,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi_movi,
                                                                      "estado",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi_movi.estado"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm12: "" }
                                                          },
                                                          [
                                                            _c("v-textarea", {
                                                              attrs: {
                                                                counter: "500",
                                                                label:
                                                                  "Observación",
                                                                "prepend-icon":
                                                                  "feedback",
                                                                rules: [
                                                                  _vm.rules_movi
                                                                    .textareaCounter
                                                                ]
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .paramApi_movi
                                                                    .moviobs,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi_movi,
                                                                    "moviobs",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi_movi.moviobs"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              sm12: "",
                                                              "px-2": ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-checkbox", {
                                                              attrs: {
                                                                label:
                                                                  "Generar Encomienda",
                                                                disabled:
                                                                  !!_vm
                                                                    .paramApi_movi
                                                                    .numDespacho &&
                                                                  !!_vm
                                                                    .paramApi_movi
                                                                    .numDespacho
                                                                    .despanumero
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.generarMovimiento,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.generarMovimiento = $$v
                                                                },
                                                                expression:
                                                                  "generarMovimiento"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.generarMovimiento
                                          ? [
                                              _c("v-divider", {
                                                staticClass: "my-4"
                                              }),
                                              _c(
                                                "div",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { sm12: "" } },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "h2_title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Generar Encomienda"
                                                          )
                                                        ]
                                                      ),
                                                      _c("v-divider"),
                                                      !_vm.loading_enc
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                sm12: "",
                                                                layout: "",
                                                                wrap: "",
                                                                "pa-4": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Código",
                                                                        type:
                                                                          "text",
                                                                        disabled:
                                                                          "",
                                                                        "prepend-icon":
                                                                          "123"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .despanumero,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "despanumero",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.despanumero"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Actividad Despacho",
                                                                        type:
                                                                          "text",
                                                                        disabled:
                                                                          "",
                                                                        "prepend-icon":
                                                                          "home_repair_service"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .data
                                                                            .nombre_add,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.data,
                                                                            "nombre_add",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "data.nombre_add"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "DatePicker",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Fecha Envio",
                                                                        required:
                                                                          "",
                                                                        disabled:
                                                                          _vm.disabledForm_enc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .despafecha_envia,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "despafecha_envia",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.despafecha_envia"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Usuario",
                                                                        type:
                                                                          "text",
                                                                        disabled:
                                                                          "",
                                                                        "prepend-icon":
                                                                          "person"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .usuario
                                                                            .nombre,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .paramApi_enc
                                                                              .usuario,
                                                                            "nombre",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.usuario.nombre"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-autocomplete",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Courier",
                                                                        items:
                                                                          _vm
                                                                            .listApi_enc
                                                                            .courriers,
                                                                        "item-value":
                                                                          "configid",
                                                                        "item-text":
                                                                          "configvalor",
                                                                        "prepend-icon":
                                                                          "home_repair_service",
                                                                        "return-object":
                                                                          "",
                                                                        disabled:
                                                                          _vm.disabledForm_enc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .courrier,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "courrier",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.courrier"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Orden Seguimiento (Obligatorio)",
                                                                        type:
                                                                          "text",
                                                                        rules: [
                                                                          _vm
                                                                            .rules_enc
                                                                            .seguimiento
                                                                        ],
                                                                        "prepend-icon":
                                                                          "list_alt",
                                                                        required:
                                                                          "",
                                                                        disabled:
                                                                          _vm.disabledForm_enc
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          _vm.handleChangeEnc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .despaseguimiento,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "despaseguimiento",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.despaseguimiento"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-autocomplete",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Localidad (Obligatorio)",
                                                                        "prepend-icon":
                                                                          "flag",
                                                                        items:
                                                                          _vm
                                                                            .listApi_enc
                                                                            .localidades,
                                                                        rules: [
                                                                          _vm
                                                                            .rules_enc
                                                                            .localidad
                                                                        ],
                                                                        "item-value":
                                                                          "locaid",
                                                                        "item-text":
                                                                          "locaname",
                                                                        required:
                                                                          "",
                                                                        "return-object":
                                                                          "",
                                                                        disabled:
                                                                          _vm.disabledForm_enc
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          _vm.handleChangeEnc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .localidad,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "localidad",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.localidad"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-autocomplete",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Tecnico",
                                                                        "prepend-icon":
                                                                          "person",
                                                                        items:
                                                                          _vm
                                                                            .listApi_enc
                                                                            .tecnicos,
                                                                        "item-value":
                                                                          "tecnicoid",
                                                                        "item-text":
                                                                          "tecniconame",
                                                                        disabled:
                                                                          "",
                                                                        "return-object":
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          _vm.handleChangeEnc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .tecnico,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "tecnico",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.tecnico"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Observación",
                                                                        counter:
                                                                          "100",
                                                                        type:
                                                                          "text",
                                                                        rules: [
                                                                          _vm
                                                                            .rules_enc
                                                                            .observacion
                                                                        ],
                                                                        "prepend-icon":
                                                                          "feedback",
                                                                        disabled:
                                                                          _vm.disabledForm_enc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .despaobs,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "despaobs",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.despaobs"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: "",
                                                                    layout: "",
                                                                    "justify-space-between":
                                                                      "",
                                                                    "align-center":
                                                                      "",
                                                                    wrap: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        sm2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-checkbox",
                                                                        {
                                                                          attrs: {
                                                                            label:
                                                                              "Costo",
                                                                            disabled:
                                                                              _vm.disabledForm_enc
                                                                          },
                                                                          on: {
                                                                            change:
                                                                              _vm.handleValorEnc
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .paramApi_enc
                                                                                .despacargo_sino,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.paramApi_enc,
                                                                                "despacargo_sino",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "paramApi_enc.despacargo_sino"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        sm7: "",
                                                                        md8: "",
                                                                        lg9: "",
                                                                        xl10:
                                                                          "",
                                                                        layout:
                                                                          "",
                                                                        "justify-end":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          attrs: {
                                                                            counter: 11,
                                                                            label:
                                                                              "Valor",
                                                                            "prepend-icon":
                                                                              "local_atm",
                                                                            type:
                                                                              "number",
                                                                            min:
                                                                              "1",
                                                                            max:
                                                                              "99999999",
                                                                            rules: [
                                                                              _vm
                                                                                .rules_enc
                                                                                .precio
                                                                            ],
                                                                            disabled:
                                                                              _vm.disabledFieldValue_enc ||
                                                                              _vm.disabledForm_enc
                                                                          },
                                                                          on: {
                                                                            change:
                                                                              _vm.handleFormatValueEnc
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .paramApi_enc
                                                                                .despacargo_valor,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.paramApi_enc,
                                                                                "despacargo_valor",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "paramApi_enc.despacargo_valor"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "DatePicker",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Fecha Recepción",
                                                                        disabled:
                                                                          _vm.disabledForm_enc
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .despafecha_recibe,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "despafecha_recibe",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.despafecha_recibe"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    sm4: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Receptor",
                                                                        type:
                                                                          "text",
                                                                        disabled:
                                                                          _vm.disabledForm_enc,
                                                                        "prepend-icon":
                                                                          "person"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .paramApi_enc
                                                                            .despareceptor,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.paramApi_enc,
                                                                            "despareceptor",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "paramApi_enc.despareceptor"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.modalDeviceList
            ? _c("AddEquipo", {
                attrs: {
                  data: _vm.data,
                  dialog: true,
                  deviceList: _vm.deviceList
                },
                on: {
                  closedModalDevices: _vm.handleClosedModalAddDevices,
                  selected: _vm.handleSelected
                }
              })
            : _vm._e(),
          _c("Confirmation", {
            attrs: {
              show: _vm.dialogPopUp,
              titulo: "Confirmación",
              mensaje:
                "Al cerrar esta ventana toda la información ingresada se perderá. ¿Está seguro que desea cerrar sin guardar?",
              textoBtnSi: _vm.$t("No Guardar"),
              textoBtnNo: _vm.$t("Continuar Creando")
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.showPopuP($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }